import storefront from "../../global/storefront";
import unwrapNodes from "../unwrapNodes";
import addProductHelpers from "../addProductHelpers";
import { productWithGroup } from "../../global/storefront/queries";

const cache = {};

const getBuyer = () => {
  const locationId = window.theme.location_id;

  if (!locationId) return null;

  const customerAccessData = localStorage.getItem("customer-access-data");
  const { access_token } = customerAccessData
    ? JSON.parse(customerAccessData)
    : { access_token: null };

  if (!access_token) return null;

  return {
    customerAccessToken: access_token,
    companyLocationId: `gid://shopify/CompanyLocation/${locationId}`,
  };
};

export default function fetchProduct(id) {
  if (id in cache) {
    return cache[id];
  }

  cache[id] = storefront
    .request({
      query: productWithGroup,
      variables: {
        id,
        buyer: getBuyer(),
      },
    })
    .then(({ data }) => {
      const output = unwrapNodes(data.product);
      addProductHelpers(output);

      return output;
    });

  return cache[id];
}
